"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.destinationsForPositionInList = exports.destinationDescription = exports.destinationsDeserialize = exports.destinationDeserialize = void 0;
const sortBy_1 = __importDefault(require("lodash/sortBy"));
const pluralize_1 = __importDefault(require("pluralize"));
const unwrap_1 = __importDefault(require("../util/unwrap"));
const deserializeArray_1 = __importDefault(require("./deserializeArray"));
const deserializeObject_1 = __importDefault(require("./deserializeObject"));
const deserializeString_1 = require("./deserializeString");
const DestinationCategory_1 = require("./DestinationCategory");
const PositionInList_1 = __importDefault(require("./PositionInList"));
function destinationDeserialize(value) {
    const object = (0, deserializeObject_1.default)(value);
    return {
        name: (0, deserializeString_1.deserializeString)(object.name),
        zoneIds: (0, deserializeString_1.stringsDeserialize)(object.zoneIds),
        category: object.category ? (0, DestinationCategory_1.destinationCategoryDesrialize)(object.category) : undefined,
    };
}
exports.destinationDeserialize = destinationDeserialize;
exports.destinationsDeserialize = (0, deserializeArray_1.default)(destinationDeserialize);
function destinationDescription(destination, zones) {
    const filteredZones = zones === null || zones === void 0 ? void 0 : zones.filter(zone => destination.zoneIds.includes(zone.id));
    return `${destination.name} (${[
        (0, unwrap_1.default)(destination.category, category => `${(0, DestinationCategory_1.destinationCategoryTitle)(category)};`),
        (filteredZones === null || filteredZones === void 0 ? void 0 : filteredZones.length)
            ? filteredZones.map(zone => zone.name).join(', ')
            : `${destination.zoneIds.length} ${(0, pluralize_1.default)('zone', destination.zoneIds.length)}`,
    ]
        .filter(Boolean)
        .join(' ')})`;
}
exports.destinationDescription = destinationDescription;
function destinationsForPositionInList(destinations, position) {
    if (position === PositionInList_1.default.last) {
        return (0, sortBy_1.default)(destinations, 'name');
    }
    return undefined;
}
exports.destinationsForPositionInList = destinationsForPositionInList;
